var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"authors",domProps:{"innerHTML":_vm._s(_vm.list_authors)}})])}
var staticRenderFns = []

export { render, staticRenderFns }